import React, { createContext, useContext, useState, useEffect } from "react";
import supabase from "../supabase-client";

const BranchContext = createContext();

export function BranchContextProvider({ children }) {
  const [branches, setBranches] = useState([]);
  const [branch, setBranchState] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBranches = async () => {
      const { data } = await supabase
        .from("branches")
        .select("*")
        .eq("is_active", true)
        .order("segment")
        .order("name");
      if (data) {
        setBranches(data);
        // Restore from localStorage or default to first branch
        const savedId = localStorage.getItem("gomove_branch_id");
        const saved = data.find((b) => b.id === parseInt(savedId));
        setBranchState(saved || data[0] || null);
      }
      setLoading(false);
    };
    fetchBranches();
  }, []);

  const setBranch = (branchObj) => {
    setBranchState(branchObj);
    if (branchObj) {
      localStorage.setItem("gomove_branch_id", String(branchObj.id));
    }
  };

  const isLargoPlazo = branch?.segment === "largo_plazo";

  return (
    <BranchContext.Provider value={{ branch, branches, setBranch, isLargoPlazo, loading }}>
      {children}
    </BranchContext.Provider>
  );
}

export function useBranch() {
  return useContext(BranchContext);
}
